export enum TldGroupStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum TldFrequency {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  BIWEEKLY = 'BIWEEKLY',
  MONTHLY = 'MONTHLY',
}

export enum TldQuotaStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  EXPIRED = 'EXPIRED',
}

export enum TldRequestStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  // INACTIVE = 'INACTIVE',
  EXPIRED = 'EXPIRED',
}

export enum TldReportStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum TldReportDetailAction {
  EXCLUDED = 'EXCLUDED',
  DEREGISTERED = 'DEREGISTERED',
}

export enum AuditLogSection {
  MERCHANTS = 'MERCHANTS',
  TRANSACTIONS = 'TRANSACTIONS',
  MERCHANT_GROUPS = 'MERCHANT_GROUPS',
  QUOTAS = 'QUOTAS',
  SCHEDULES = 'SCHEDULES',
  REQUESTS = 'REQUESTS',
  REPORTS = 'REPORTS',
}

export enum AuditLogAction {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  REGISTER = 'REGISTER',
  DEREGISTER = 'DEREGISTER',
}

export enum RemarkOptionType {
  GENERAL = 'GENERAL',
  SPECIFIC = 'SPECIFIC',
}

export enum RemarkOptionLabel {
  SUSPICIOUS_ALERT = 'SUSPICIOUS_ALERT',
}

export enum RemarkOptionStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum RemarkOptionLang {
  EN = 'en',
  SC = 'sc',
  TC = 'tc',
}

export enum TldReviewStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum TldInternalRemarkSourceType {
  SI = 'SI',
  TLD = 'TLD',
  LEGACY = 'LEGACY',
}

export enum TldInternalRemarkType {
  REMARK_OPTION = 'REMARK_OPTION',
  CATEGORY = 'CATEGORY',
  LEGACY = 'LEGACY',
  CUSTOM = 'CUSTOM',
}

export enum TldInternalRemarkProcessKey {
  CARRIED = 'CARRIED',
  NOT_CARRIED = 'NOT_CARRIED',
  UNKNOWN_ON_INTERNET = 'UNKNOWN_ON_INTERNET',
}
